//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'rb-swiper-bar',
  props: {
    index: {
      type: Number,
      default: 0,
    },
    progress: {
      type: Number,
      default: 0,
    },
    maxIndex: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    width() {
      return 100 / this.maxIndex
    },
    translateX() {
      return this.width * this.index
    },
  },
}
